// src/app/views/prueba-confesional/listado-prueba-confesional/listado-prueba-confesional.component.ts
import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatTableModule } from '@angular/material/table';
import { AccionesDialog } from '@models/base/identificadores.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { AppRoleDirective } from '@directives/appRoles/app-role.directive';
import { SharedModule } from '@modules/shared.module';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogParams } from '@interfaces/dialogParam.interface.model';
import { ButtonFilterTableComponent } from '@component/button-filter-table/button-filter-table.component';
import { ButtonFilterTableClearComponent } from '@component/button-filter-table-clear/button-filter-table-clear.component';
import { StatusBadgeComponent } from '@component/status-badge/status-badge.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { MatSelectModule } from '@angular/material/select';
import { ButtonActionComponent } from '@component/button-action/button-action.component';
import { BtnNuevoUsuarioComponent } from '@views/usuarios/btn-nuevo-usuario/btn-nuevo-usuario.component';
import { PruebaConfesionalDto } from '@models/pruebas/pruebaConfesional/pruebaConfesionalDto.model';
import { PruebaConfesionalService } from '@services/pruebas/pruebaConfesional/pruebaConfesional.service';
import { DialogFormPruebaConfesionalComponent } from '../dialog-form-prueba-confesional/dialog-form-prueba-confesional.component';
import { InputFilterTableComponent } from '@component/input-filter-table/input-filter-table.component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    NgxSpinnerModule,
    AppRolesDirective,
    SinDatosParaMostrarComponent,
    BtnNuevoUsuarioComponent,
    MatCheckboxModule,
    MatSlideToggleModule,
    ButtonNewComponent,
    StatusBadgeComponent,
    ButtonActionComponent,
    MatTooltipModule,
    ButtonFilterTableClearComponent,
    ButtonFilterTableComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatTableModule,
    MatSelectModule,
    NgxSpinnerModule,
    InputFilterTableComponent
  ],
  selector: 'app-listado-prueba-confesional',
  templateUrl: 'listado-prueba-confesional.component.html',
  styleUrls: ['./listado-prueba-confesional.component.css'],
})
export class ListadoPruebaConfesionalComponent implements OnInit {

  @Input() idExpediente!: number;
  @Input() showHeader: boolean = true;
  data = false;
  dataSource = new MatTableDataSource<PruebaConfesionalDto>();
  displayedColumns: string[] = [];
  formFilter!: FormGroup;
  accionesDialog = AccionesDialog;

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;

  private paginator!: MatPaginator;
  private sort!: MatSort;
  checkedFiltroAvanzado = false;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  constructor(
    public dialog: MatDialog,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private pruebaConfesionalService: PruebaConfesionalService,
    private formBuilder: FormBuilder
  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ['descripcion', 'personaAbsolvente', 'accion'] :
        ['descripcion', 'personaAbsolvente', 'estadoPrueba', 'fechaAudiencia', 'usuarioResponsable', 'accion'];
    });

    this.initializeForm();
  }

  ngOnInit() {
    this.aplicarFiltro();
  }

  initializeForm() {
    this.formFilter = this.formBuilder.group({
      Descripcion: [''],
      PersonaAbsolvente: [''],
      EstadoPrueba: [''],
      UsuarioResponsable: [''],
      FechaAudienciaDesde: [''],
      FechaAudienciaHasta: ['']
    });
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }

  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      ...entidad,
      accion,
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.data = data;
    dialogConfig.height = "80%";

    switch (accion) {
      case AccionesDialog.Ver:
        dialogConfig.width = "80%";
        break;
      default:
        dialogConfig.width = "70%";
        break;
    }

    const dialogRef = this.dialog.open(DialogFormPruebaConfesionalComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
        case AccionesDialog.Modificar:
        case AccionesDialog.Eliminar:
          this.aplicarFiltro();
          break;
        default:
          break;
      }
    });
  }

  sortingDataAccessor() {
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'descripcion':
          return item.descripcion?.toLowerCase() || '';
        case 'personaAbsolvente':
          return item.personaAbsolvente?.nombreCompleto?.toLowerCase() || '';
        case 'estadoPrueba':
          return item.estadoPrueba?.descripcion?.toLowerCase() || '';
        case 'usuarioResponsable':
          return item.usuarioResponsable?.nombreCompleto?.toLowerCase() || '';
        case 'fechaAudiencia':
          return item.fechaAudiencia || '';
        default:
          return item[property];
      }
    };
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.sortingDataAccessor();
    this.iniciaFiltroTabla();
  }

  iniciaFiltroTabla() {
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const search = filter.trim().toLowerCase();
      return (
        data.descripcion?.toLowerCase().includes(search) ||
        data.personaAbsolvente?.nombreCompleto?.toLowerCase().includes(search) ||
        data.estadoPrueba?.descripcion?.toLowerCase().includes(search) ||
        data.usuarioResponsable?.nombreCompleto?.toLowerCase().includes(search) ||
        data.observaciones?.toLowerCase().includes(search)
      );
    };
  }

  guardarFiltro() {
    const filtro = this.formFilter.value;
    localStorage.setItem('filtroPruebaConfesionalGuardado', JSON.stringify(filtro));
  }

  limpiarFiltro() {
    this.formFilter.reset();
    localStorage.removeItem('filtroPruebaConfesionalGuardado');
    this.aplicarFiltro();
  }

  filtrosAvanzados(event: any) {
    this.checkedFiltroAvanzado = event.checked;
  }

  aplicarFiltro() {
    this.getAllByFilter();
    this.guardarFiltro();
  }

  getAllByFilter() {
    if (this.idExpediente) {
      this.spinner.show("spPruebasConfesional");

      this.pruebaConfesionalService.getAllByIdExpediente(this.idExpediente)
        .subscribe({
          next: (data) => {
            this.spinner.hide("spPruebasConfesional");
            this.dataSource.data = data;
            this.data = this.dataSource.data.length >= 1;
          },
          error: (error) => {
            this.spinner.hide("spPruebasConfesional");
            this.snackBar.showError(error, "Error");
          }
        });
    }
  }

  applyFilter(event: any) {
    if (event && event.target && event.target instanceof HTMLInputElement) {
      let filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }

  isFalsy(valor: any) {
    return isFalsy(valor);
  }
}
